import { useState } from 'react';
import {
  acceptAllConsentPreferences,
  acceptEssentialOnlyConsentPreferences,
  getConsentPreferences,
  hasSavedConsentPreferences,
  saveConsentPreferences,
} from '../services/consentPreferences';

function ConsentBanner() {
  const [visible, setVisible] = useState(() => !hasSavedConsentPreferences());
  const [expanded, setExpanded] = useState(false);
  const [preferences, setPreferences] = useState(() => getConsentPreferences());

  const handleEssentialOnly = () => {
    setPreferences(acceptEssentialOnlyConsentPreferences());
    setVisible(false);
  };

  const handleAcceptAll = () => {
    setPreferences(acceptAllConsentPreferences());
    setVisible(false);
  };

  const handleSaveChoices = () => {
    setPreferences(saveConsentPreferences(preferences));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="position-fixed start-0 end-0 bottom-0 p-3"
      style={{ zIndex: 1085, pointerEvents: 'none' }}
    >
      <div className="container" style={{ pointerEvents: 'auto' }}>
        <div className="card shadow-lg border-0">
          <div className="card-body p-4">
            <div className="d-flex flex-column flex-lg-row justify-content-between gap-3">
              <div>
                <h2 className="h5 mb-2">Privacy and cookie choices</h2>
                <p className="text-muted mb-2">
                  YubuMarket uses essential storage for login and security. With your permission,
                  we also use analytics and marketing tools to understand site usage and improve
                  campaigns.
                </p>
                <p className="small text-muted mb-0">
                  You can review our Privacy Policy, Terms &amp; Conditions, Shipping Policy, and
                  Returns Policy from the footer at any time.
                </p>
              </div>
              <div className="d-flex flex-column gap-2">
                <button type="button" className="btn btn-primary" onClick={handleAcceptAll}>
                  Accept analytics and marketing
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={handleEssentialOnly}
                >
                  Use essential only
                </button>
                <button
                  type="button"
                  className="btn btn-link px-0 text-start"
                  onClick={() => setExpanded((prev) => !prev)}
                >
                  {expanded ? 'Hide choices' : 'Customize choices'}
                </button>
              </div>
            </div>

            {expanded ? (
              <div className="row g-3 mt-1">
                <div className="col-12 col-md-4">
                  <div className="border rounded p-3 h-100">
                    <div className="fw-semibold mb-1">Essential</div>
                    <div className="small text-muted mb-2">
                      Required for login, security, and basic site operation.
                    </div>
                    <div className="form-check form-switch">
                      <input className="form-check-input" type="checkbox" checked readOnly />
                      <label className="form-check-label">Always on</label>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="border rounded p-3 h-100">
                    <div className="fw-semibold mb-1">Analytics</div>
                    <div className="small text-muted mb-2">
                      Helps us measure traffic, feature usage, and performance trends.
                    </div>
                    <div className="form-check form-switch">
                      <input
                        id="consent-analytics"
                        className="form-check-input"
                        type="checkbox"
                        checked={preferences.analytics}
                        onChange={(event) =>
                          setPreferences((prev) => ({ ...prev, analytics: event.target.checked }))
                        }
                      />
                      <label className="form-check-label" htmlFor="consent-analytics">
                        Allow analytics
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="border rounded p-3 h-100">
                    <div className="fw-semibold mb-1">Marketing</div>
                    <div className="small text-muted mb-2">
                      Helps us measure ad performance and improve acquisition campaigns.
                    </div>
                    <div className="form-check form-switch">
                      <input
                        id="consent-marketing"
                        className="form-check-input"
                        type="checkbox"
                        checked={preferences.marketing}
                        onChange={(event) =>
                          setPreferences((prev) => ({ ...prev, marketing: event.target.checked }))
                        }
                      />
                      <label className="form-check-label" htmlFor="consent-marketing">
                        Allow marketing
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <button type="button" className="btn btn-dark" onClick={handleSaveChoices}>
                    Save choices
                  </button>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConsentBanner;
